import { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useQuery, skipToken } from '@tanstack/react-query';
import { applicationQueryKey } from '../../queries/applicationQueries';
import { ApplicationParameters } from '../types/ApplicationParameters';

export const useRedirectIfComplete = (disabled = false) => {
    const { entryGuid } = useParams<ApplicationParameters>();
    const { data: complete } = useQuery({
        queryKey: applicationQueryKey(entryGuid ?? ''),
        queryFn: skipToken,
        select: (d) => d.complete,
    });
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        if (!disabled && complete === true) {
            navigate('/home');
        }
    }, [disabled, complete, navigate, pathname]);
};
